{
  "name": "mm-org-admin-ui",
  "version": "1.16.0",
  "engines": {
    "node": "^22.13.0",
    "npm": "^10.9.2"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "watch:libraries": "for dir in libraries/*/; do ng build $(basename $dir) --watch & done; wait",
    "test": "ng test",
    "lint": "ng lint --fix",
    "test:all": "npm run test:mm-org-admin && npm run test:mm-org-group-admin && npm run test:lib && npm run test:libraries",
    "test:mm-org-admin": "ng test mm-org-admin",
    "test:mm-org-group-admin": "ng test mm-org-group-admin",
    "test:lib": "ng test lib",
    "test:libraries": "for dir in libraries/*/; do lib=$(basename $dir); if [ \"$lib\" != \"shared-styles\" ] && [ \"$lib\" != \"test-setup\" ]; then ng test $lib; fi; done",
    "build:libraries": "for dir in libraries/*/; do lib=$(basename $dir); if [ \"$lib\" != \"shared-styles\" ] && [ \"$lib\" != \"test-setup\" ]; then ng build $lib; fi; done",
    "build:all": "ng build lib && npm run build:libraries && ng build mm-org-group-admin && ng build mm-org-admin",
    "build:mm-org-admin": "ng build lib && npm run build:libraries && ng build mm-org-admin",
    "build:mm-org-group-admin": "ng build lib && npm run build:libraries && ng build mm-org-group-admin",
    "build:lib": "ng build lib",
    "serve:mm-org-admin": "ng build lib && npm run build:libraries && ng serve mm-org-admin",
    "serve:mm-org-admin:dev-ssl": "ng build lib && npm run build:libraries && ng serve mm-org-admin -c development --ssl true --ssl-key dev-ssl/wildcard.modmed.dev.key --ssl-cert dev-ssl/wildcard.modmed.dev.crt --host modmed.dev",
    "serve:mm-org-group-admin": "ng build lib && npm run build:libraries && ng serve mm-org-group-admin",
    "prepare": "is-ci || husky install",
    "circular-dependency:list": "npx madge --extensions ts ./ --circular",
    "circular-dependency:graph": "npx madge --extensions ts ./ --image circular-dependency-graph.png",
    "memory-leak": "node --expose-gc ./node_modules/.bin/jest --runInBand --logHeapUsage",
    "memory-leak:browser": "npm run memory-leak --inspect-brk"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.26",
    "@angular/common": "^20.3.26",
    "@angular/compiler": "^20.3.26",
    "@angular/core": "^20.3.26",
    "@angular/forms": "^20.3.26",
    "@angular/platform-browser": "^20.3.26",
    "@angular/platform-browser-dynamic": "^20.3.26",
    "@angular/router": "^20.3.26",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-regular-svg-icons": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ng-select/ng-select": "^15.2.0",
    "@popperjs/core": "^2.11.8",
    "@primeng/themes": "^19.0.7",
    "@stomp/rx-stomp": "^2.3.0",
    "@stomp/stompjs": "^7.2.0",
    "@types/luxon": "^3.4.2",
    "@typescript-eslint/typescript-estree": "^8.65.0",
    "bootstrap": "^5.3.2",
    "brace-expansion": "^5.0.8",
    "file-saver": "^2.0.5",
    "font-awesome": "^4.7.0",
    "inputmask": "^5.0.9",
    "keycloak-angular": "^20.1.0",
    "keycloak-js": "^18.0.1",
    "luxon": "^3.5.0",
    "minimatch": "^10.2.6",
    "ngx-bootstrap": "^20.0.2",
    "ngx-toastr": "^19.0.0",
    "postcss": "^8.5.25",
    "primeng": "^20.4.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/jest": "^20.0.0",
    "@angular/build": "^20.3.32",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.26",
    "@angular/localize": "^20.3.26",
    "@eslint/eslintrc": "^3.3.6",
    "@eslint/js": "^9.18.0",
    "@happy-dom/jest-environment": "^20.11.1",
    "@stylistic/eslint-plugin": "^4.0.1",
    "@types/file-saver": "^2.0.7",
    "@types/inputmask": "^5.0.7",
    "@types/jest": "^29.5.14",
    "@types/luxon": "^3.4.2",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "angular-eslint": "20.7.0",
    "babel-jest": "^29.7.0",
    "eslint": "^9.28.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-prefer-arrow": "~1.2.3",
    "happy-dom": "^20.11.1",
    "husky": "^9.1.7",
    "is-ci": "^4.1.0",
    "jasmine-core": "~5.6.0",
    "jest": "^29.7.0",
    "madge": "^8.0.0",
    "ng-mocks": "^14.15.3",
    "ng-packagr": "^20.3.2",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.33.1"
  }
}
